import { render, staticRenderFns } from "./BusinessActivitiesCard.vue?vue&type=template&id=10056f8a&"
import script from "./BusinessActivitiesCard.vue?vue&type=script&lang=ts&"
export * from "./BusinessActivitiesCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports